var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-with-navigation" }, [
    _c(
      "div",
      {
        staticClass: "layout-with-navigation__sidebar",
        style: _vm.styleSidebar
      },
      [_vm._t("navigation")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "layout-with-navigation__content" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }